export const approvalChains = {
  manageApprovalChains: {
    approvalChainActionMenu: {
      approvalChainActions: 'Approval chain actions',
      delete: 'Delete',
      duplicate: 'Duplicate',
      edit: 'Edit',
    },
    approvalChainEditorPanel: {
      allApprovalChains: 'All approval chains',
      approvalChainNotFound: 'Approval chain not found',
      approversWerenTCopiedAdd:
        "People weren't copied: add an approver to each step without a role before saving.",
      backToApprovalChains: 'Back to approval chains',
      closePanel: 'Close editor',
      configureAnApprovalChainFor: 'Name the approval chain and define its steps.',
      copiedFrom: 'Copied from "{{approvalChainName}}"',
      createApprovalChain: 'Create approval chain',
      created: 'Created "{{approvalChainName}}".',
      editApprovalChain: 'Edit approval chain',
      failedToCreateApprovalChain: 'Failed to create approval chain.',
      failedToSaveApprovalChain: 'Failed to save approval chain.',
      saveChanges: 'Save changes',
      savedChangesTo: 'Saved changes to "{{approvalChainName}}".',
      thisApprovalChainMayHaveBeen:
        'This approval chain may have been deleted. Close the editor and pick another.',
    },
    approvalChainForm: {
      addStep: 'Add step',
      applyToExistingFolders: 'Apply to existing folders',
      approvalChainName: 'Approval chain name',
      approvalSteps: 'Approval steps',
      autoApplyOnAnotherChain:
        'Only one approval chain per project can auto-apply. Turn it off on "{{approvalChainName}}" first.',
      autoApplyToNewFolders: 'Auto-apply to new folders',
      cancel: 'Cancel',
      eachStepUnlocksOnlyAfter:
        'Each step unlocks only after the previous one is approved. Turn off to open every step at once.',
      eGStandardContentApproval: 'e.g. Standard content approval',
      newFoldersCreatedInThis:
        'New folders created in this project will use this approval chain automatically.',
      oneTimeActionOnSave:
        "One-time action on save: applies this approval chain to assets in existing folders that don't have one yet. Approved assets are skipped.",
      runStepsInOrder: 'Run steps in order',
    },
    approvalChainListPanel: {
      appliedTo: 'Applied to {{folders}} · {{assets}}',
      approvalChains: 'Approval chains',
      assetCount_one: '{{count}} asset',
      assetCount_other: '{{count}} assets',
      auto: 'Auto',
      browseTheApprovalChains: 'Browse the approval chains available in this project.',
      closePanel: 'Close list',
      copyFromAnotherProject: 'Copy from another project',
      createAnApprovalChainToStandardize:
        'Create an approval chain to standardize approvals across folders.',
      createNewApprovalChain: 'New approval chain',
      deleted: 'Deleted "{{approvalChainName}}".',
      deletedAssetsReverted_one:
        'Deleted "{{approvalChainName}}". {{count}} asset reverted to no approval chain.',
      deletedAssetsReverted_other:
        'Deleted "{{approvalChainName}}". {{count}} assets reverted to no approval chain.',
      duplicatedAs: 'Duplicated "{{sourceName}}" as "{{newName}}".',
      failedToDeleteApprovalChain: 'Failed to delete approval chain.',
      failedToDuplicateApprovalChain: 'Failed to duplicate approval chain.',
      folderCount_one: '{{count}} folder',
      folderCount_other: '{{count}} folders',
      name: 'Name',
      noApprovalChainsHaveBeen: 'No approval chains have been defined for this project.',
      noApprovalChainsYet: 'No approval chains yet',
      on: 'On',
      stepCount_one: '{{count}} step',
      stepCount_other: '{{count}} steps',
      steps: 'Steps',
      stepTrailSeparator: ' → ',
      thisApprovalChainIsCurrentlyAssigned_one:
        'This approval chain is currently assigned to {{count}} asset. Deleting it will revert that asset to no approval chain, and send it back to To review if the chain had fully approved it. This action cannot be undone.',
      thisApprovalChainIsCurrentlyAssigned_other:
        'This approval chain is currently assigned to {{count}} assets. Deleting it will revert those assets to no approval chain, and send any the chain had fully approved back to To review. This action cannot be undone.',
    },
    approvalChainStepRow: {
      addApprovers: 'Add approvers',
      approvalThreshold: 'Approval threshold',
      approvers: 'Approvers',
      approversForStep: 'Approvers for step {{step}}',
      eGLegalReview: 'e.g. Legal review',
      moveDown: 'Move down',
      moveStepDown: 'Move step {{step}} down',
      moveStepUp: 'Move step {{step}} up',
      moveUp: 'Move up',
      remove: 'Remove',
      removeApprover: 'Remove {{name}}',
      removeStep: 'Remove step {{step}}',
      reorder: 'Drag to reorder',
      reorderStep: 'Reorder step {{step}}',
      requiredApprovers: 'Required approvers',
      stepName: 'Step name',
      stepNumber: 'Step {{stepNumber}}',
    },
    approverPicker: {
      anyoneWithThisRole: 'Anyone with this role',
      nobodyHoldsRoleYet: 'Nobody in this project has the {{role}} role yet.',
      people: 'People',
      removeRole: 'Remove the {{name}} role',
      roles: 'Roles',
    },
    copyApprovalChainDialog: {
      approvalChainsIn: 'Approval chains in {{project}}',
      backToProjects: 'Back to projects',
      copyFromAnotherProject: 'Copy from another project',
      failedToCopyApprovalChain: 'Failed to copy approval chain.',
      loading: 'Loading…',
      loadMore: 'Load more',
      noOtherProjectsFound: 'No other projects found.',
      searchProjects: 'Search projects',
      searchProjectsLabel: 'Search projects',
      stepCount_one: '{{count}} step',
      stepCount_other: '{{count}} steps',
      thisProjectHasNoApprovalChains: 'This project has no approval chains to copy.',
      untitledProject: 'Untitled project',
    },
    editApprovalChainWarningDialog: {
      cancel: 'Cancel',
      currentlyActiveOnAssets_one:
        'This approval chain is currently active on {{count}} asset. Changes will affect in-progress approvals.',
      currentlyActiveOnAssets_other:
        'This approval chain is currently active on {{count}} assets. Changes will affect in-progress approvals.',
      changingTheExecutionOrderRestarts:
        'Changing whether steps are approved in order or in any order discards every approval on this chain. Every asset using it starts again from the first step.',
      editThisApprovalChain: 'Edit this approval chain?',
      proceed: 'Proceed',
    },
    schema: {
      allApproversNotWithRole:
        'Not available with a role: who holds it can change while assets are in review.',
      addAtLeastOneApprover: 'Add at least one approver',
      addAtLeastOneStep: 'Add at least one step',
      allApprovers: 'All approvers',
      anApprovalChainCanHaveAt: 'An approval chain can have at most {{max}} steps',
      approvalChainNameIsRequired: 'Approval chain name is required',
      atLeastNApprovers: 'At least N approvers',
      atLeastOneApprover: 'At least one approver',
      enterTheNumberOfRequired: 'Enter the number of required approvers',
      stepNameIsRequired: 'Step name is required',
      stepRequiresAtLeastApprovers:
        'Step {{step}} requires at least {{required}} approvers but only {{assigned}} users are assigned',
      stepRoleHasNoApprovers:
        'Step {{step}} needs at least one approver, but nobody is assigned or holds the {{role}} role',
      stepRoleRequiresAtLeastApprovers:
        'Step {{step}} requires at least {{required}} approvers but only {{available}} users are assigned or hold the {{role}} role',
    },
  },
} as const;
